import Cookies from 'js-cookie'

import { fetchGuruToken, fetchLMSRole } from '../../auth'
import { SESSION } from '../../constant'

export async function createGuruSession(idToken: string): Promise<void> {
  if (!idToken) {
    throw new Error('ID token is required')
  }

  const guruSessionData = await fetchGuruToken({ tokenId: idToken })
  if (!guruSessionData.user) {
    throw new Error(guruSessionData.error)
  }

  const roleData = await fetchLMSRole({
    guruToken: guruSessionData.user.guruToken,
  })
  if (roleData.error) {
    throw new Error(roleData.error)
  }

  const user = {
    ...guruSessionData.user,
    user: {
      ...guruSessionData.user.user,
      LMSRole: roleData.LMSRole,
      lptkId: roleData.lptkId,
    },
  }

  Cookies.set(SESSION.USER_SESSION, JSON.stringify(user), {
    expires: new Date(user.expiredAt),
    path: '/',
  })
}
